import { useEffect, useState } from "react";

import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import CheckoutFormNew from "./CheckoutFormNew";
import { loadStripe } from "@stripe/stripe-js";
import tierHeader from "./tierHeader"
import { useNavigate } from "react-router-dom";
import '../design/Redirect.css';

export const TestFoundersClubMonthlyPriceID = "price_1Pya2A2KS8DEwxEgeKfOGcfM"
export const TestFoundersClubAnnualPriceID = "price_1PyZPW2KS8DEwxEgjImfVmjE"

export const FoundersClubMonthlyPriceID = "price_1QXlny2KS8DEwxEgn1GsTEnW"
export const FoundersClubAnnualPriceID = "price_1QklbO2KS8DEwxEgTLPau2WU"



function Foundersclub() {
  const navigate = useNavigate();

  /*
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    fetch("https://payment-pqnu.onrender.com/config").then(async (r) => {
      const { publishableKey } = await r.json();
      setStripePromise(loadStripe(publishableKey));
    });
  }, []);


  return (
    <>
    
    {tierHeader("Founders' Club Pro")}
      {stripePromise && (
        <Elements stripe={stripePromise} >
          <CheckoutFormNew tier = {2} monthly={FoundersClubMonthlyPriceID} annual={FoundersClubAnnualPriceID} founders = {true}/>
        </Elements>
      )}
    </>
  );
  */
  return (
    <>
    <div style={{
      display: 'grid',
      placeItems: 'center',
      textAlign: 'center',
      marginTop: '50px',
      marginLeft: '10px',
      marginRight: '10px'
    }}>
    <label className="redirect-message" > 
      The Founders' Club has now closed. Please click below to sign up for a Pro membership. 
    </label>
    <button onClick={() => navigate("/pro")} id = "submit">
      Sign-up
    </button>
    </div>
    
    
    </>
  );

}

export default Foundersclub;